module.exports = __webpack_public_path__ + "img/garage.f553a45e.svg";